import { Component, EventEmitter, forwardRef, HostListener, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => {};

@Component({
  selector: 'app-ep-toggle-switch',
  templateUrl: './ep-toggle-switch.component.html',
  styleUrls: ['./ep-toggle-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EpToggleSwitchComponent),
      multi: true,
    },
  ],
})
export class EpToggleSwitchComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Output() byChange = new EventEmitter<boolean>();

  private innerValue: boolean = false;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: boolean) => void = noop;

  get value(): boolean {
    return this.innerValue;
  }

  set value(v: boolean) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  @HostListener('click', ['$event.target'])
  onToggle(target: HTMLInputElement) {
    if (this.disabled && target.id === 'checkbox') {
      this.innerValue = !this.innerValue;
      this.byChange.emit(this.innerValue);
    }
  }

  public writeValue(obj: boolean): void {
    if (obj !== this.innerValue) {
      this.innerValue = obj;
    }
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
